import { createContext, useContext } from "react";

export type Mode = "dark" | "light" | "beef";
export const THEMES = ["green", "beef"] as const;
export type Theme = (typeof THEMES)[number];

export const isTheme = (value: unknown): value is Theme => THEMES.some((theme) => theme === value);
export type SelectedMode = Mode | "system";

export interface ThemeProviderState {
  mode: Mode;
  selectedMode: SelectedMode;
  theme: Theme;
  setSelectedMode: (mode: SelectedMode) => void;
  setTheme: (theme: Theme) => void;
}

export const initialMode = "system";
export const initialTheme = "green";

const initialState: ThemeProviderState = {
  mode: "light",
  selectedMode: initialMode,
  theme: initialTheme,
  setSelectedMode: () => null,
  setTheme: () => null,
};

export const ThemeProviderContext = createContext<ThemeProviderState>(initialState);

export const useTheme = () => {
  const context = useContext(ThemeProviderContext);

  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return context;
};
